import React, {Component} from 'react'
import {Input} from 'reactstrap'
import {withSubscription} from '../HOC/subscription'

export default (schema, dataStructure, uniqueKey, displayFields, variables = []) => {

    class Select extends Component{
        render(){
            const {data, value, defaultLabel} = this.props

            return (
                <Input type="select" {...this.props} onChange={(event) => this.props.onChange(event.target.value)} value={value || ''}>
                    <option value="">{(defaultLabel) ? defaultLabel : '---Please Select---'}</option>
                    {(data && data[schema]) && data[schema].map((value, index) => <option key={index} value={value[uniqueKey]}>
                        {displayFields.map(field => value[field]).join(' ')}
                        </option>)}
                </Input>
            )
        }
    }

    return withSubscription(Select, schema, dataStructure, uniqueKey, variables)
}
